import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';

var Panel = /*#__PURE__*/function (_React$Component) {
  _inherits(Panel, _React$Component);

  var _super = _createSuper(Panel);

  function Panel() {
    var _this;

    _classCallCheck(this, Panel);

    _this = _super.apply(this, arguments);
    _this.state = {
      collapsed: _this.props.collapsed === undefined ? !!_this.props.defaultCollapsed : _this.props.collapsed
    };

    _this.handleCollapse = function () {
      var collapsed = _this.state.collapsed;
      var nextState = !collapsed;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          collapsedProps = _this$props.collapsed;

      if (typeof collapsedProps !== 'boolean') {
        _this.setState({
          collapsed: nextState
        });
      }

      onChange(nextState);
    };

    _this.renderTitle = function (title) {
      var _this$props2 = _this.props,
          collapsable = _this$props2.collapsable,
          extra = _this$props2.extra,
          bordered = _this$props2.bordered;
      var collapsed = _this.state.collapsed;
      var collapseClass = classNames({
        'roo-icon': true,
        'roo-icon-chevron-up': !collapsed,
        'roo-icon-chevron-down': collapsed
      });
      var showArrow = /*#__PURE__*/React.createElement("span", {
        onClick: _this.handleCollapse,
        className: "roo-panel-collapse-flag"
      }, /*#__PURE__*/React.createElement("i", {
        className: collapseClass
      }));
      var headCls = classNames('roo-panel-heading', {
        'roo-panel-heading-padding': collapsed && !bordered
      });
      return /*#__PURE__*/React.createElement("div", {
        className: headCls
      }, /*#__PURE__*/React.createElement("h3", {
        className: "roo-panel-title"
      }, title, /*#__PURE__*/React.createElement("span", {
        className: "float-right"
      }, extra, collapsable && showArrow)));
    };

    return _this;
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          footer = _this$props3.footer,
          bordered = _this$props3.bordered,
          style = _this$props3.style,
          className = _this$props3.className,
          children = _this$props3.children;
      var collapsed = this.state.collapsed;
      var containerClassName = classNames({
        'roo-panel': true,
        'roo-panel-default': !bordered,
        'roo-panel-bordered': bordered
      }, className);
      var bodyClassName = classNames({
        'roo-panel-body': true,
        hidden: collapsed === true
      });
      return /*#__PURE__*/React.createElement("div", {
        className: containerClassName,
        style: style
      }, title && this.renderTitle(title), /*#__PURE__*/React.createElement("div", {
        className: bodyClassName
      }, children), footer && /*#__PURE__*/React.createElement("div", {
        className: "roo-panel-footer"
      }, footer));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.collapsed !== undefined) {
        return {
          collapsed: nextProps.collapsed
        };
      }

      return null;
    }
  }]);

  return Panel;
}(React.Component);

Panel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  extra: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  collapsable: PropTypes.bool,
  bordered: PropTypes.bool,
  defaultCollapsed: PropTypes.bool,
  collapsed: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func
};
Panel.defaultProps = {
  title: '',
  footer: '',
  collapsable: false,
  defaultCollapsed: undefined,
  collapsed: undefined,
  className: '',
  style: {},
  extra: '',
  bordered: false,
  onChange: function onChange() {}
};
polyfill(Panel);
export default Panel;